export enum ResponseStatus {
  PENDING,
  SUCCESS,
  ERROR,

  NO_PARAMETER,
  WRONG_PARAMETER,
}